import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { TAG_CREATE_ENDPOINT } from "../../../config/urls";
import { useAuth } from "../../../hooks/AuthProvider";
import axios from "axios";
import { Close } from "@mui/icons-material";

const CreateTagModal = ({ open, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [tagName, setTagName] = useState("");

  const { getValidToken } = useAuth();

  const handleCancel = () => {
    setTagName("");
    setError(null);
    handleClose();
  };

  const validateForm = () => {
    if (!tagName.trim()) return "Tag Name is required.";
  };

  const createTag = async () => {
    setLoading(true);
    setError(null);

    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      setLoading(false);
      return;
    }

    try {
      const payload = {
        name: tagName,
      };

      const apiUrl = TAG_CREATE_ENDPOINT;

      const token = await getValidToken();
      const tenant = localStorage.getItem("tenant");

      const response = await axios.post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "X-Tenant-Id": tenant,
        },
      });

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Error: " + response.data.error);
      }

      handleCancel();
    } catch (err) {
      if (err.response?.data) {
        if (typeof err.response.data === "object") {
          const firstError = Object.values(err.response.data)[0];
          if (Array.isArray(firstError)) {
            setError(firstError[0]);
          } else {
            setError(firstError);
          }
        } else {
          setError(err.response.data);
        }
      } else if (err.message) {
        setError("Failed to create tag: " + err.message);
      } else {
        setError("Failed to create tag.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      sx={{ zIndex: 1204 }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Create Tag
        <IconButton aria-label="close" onClick={handleCancel}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} pt={2}>
          {error && (
            <Alert severity="error">{typeof error === "string" && error}</Alert>
          )}

          <TextField
            label="Tag Name"
            value={tagName}
            onChange={(e) => setTagName(e.target.value)}
            fullWidth
            required
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={createTag}
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateTagModal;
